import { useState, useRef, useEffect } from 'react';
import dayjs from 'dayjs';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import { DateRangePicker } from '../../../../components/DateTimePicker';

import * as FollowCompanyStyles from '../../../FollowCompany/FollowCompany.styles';
import * as Styles from '../News.styles';

export default function DateDropdown({ onChange, startDate, endDate }) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const [selectedDate, setSelectedDate] = useState('');
  const [startDateValue, setStartDateValue] = useState(null);
  const [endDateValue, setEndDateValue] = useState(null);

  const handleDateChange = (_startDate, _endDate) => {
    setSelectedDate('1');
    setStartDateValue(_startDate);
    setEndDateValue(_endDate);
    if (onChange) {
      onChange(_startDate, _endDate);
    }
    handleToggle();
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    handleToggle();
  };

  const handleSelectAll = () => {
    setSelectedDate('-1');
    handleToggle();
    if (onChange) {
      onChange(null, null);
    }
  };

  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current?.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const getDateLabel = () => {
    if (!selectedDate) {
      return 'Chọn ngày';
    }
    if (selectedDate === '-1') {
      return 'Tất cả ngày';
    }
    if (!endDateValue) {
      return `${dayjs(startDateValue).format('DD/MM/YYYY')}`;
    }
    return `${dayjs(startDateValue).format('DD/MM/YYYY')} - ${dayjs(
      endDateValue
    ).format('DD/MM/YYYY')}`;
  };

  return (
    <Styles.DateDropdownWrapper>
      <FollowCompanyStyles.FakeDropdown
        ref={anchorRef}
        id="composition-button"
        aria-controls={open ? 'composition-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        className={open ? 'opened' : ''}
      >
        <span>{getDateLabel()}</span>
        <ArrowDropDownIcon />
      </FollowCompanyStyles.FakeDropdown>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        placement="bottom-start"
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom-start' ? 'left top' : 'left bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <FollowCompanyStyles.MenuWrapper>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                  >
                    <MenuItem onClick={handleSelectAll}>Tất cả ngày</MenuItem>
                    <MenuItem>
                      <span>Hoặc</span>{' '}
                      <DateRangePicker
                        startDate={startDateValue}
                        endDate={endDateValue}
                        onChange={handleDateChange}
                        maxDate={new Date()}
                        defaultStartDate={new Date(dayjs().subtract(4, 'day'))}
                      />
                    </MenuItem>
                  </MenuList>
                </FollowCompanyStyles.MenuWrapper>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Styles.DateDropdownWrapper>
  );
}
